import React from 'react';
import {
  Badge, Box, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader,
  ModalOverlay, Text,
} from '@chakra-ui/react';
import { FiCheckCircle, FiXCircle, FiExternalLink } from 'react-icons/fi';
import { SalesBibleRow } from '../../hooks/useSalesBible';
import { STATE_COLOR } from './SalesBibleRow';

// item 1144 (Chad) — the job's full lifecycle report: every guided rule graded green/red
// (proposal approved → WO created → each invoice's chain → fully invoiced), a plain-words
// verdict for WHY it's still In Progress, and links straight to each document. The trail is
// computed by useSalesBible from the same facts as the STATUS column — they cannot disagree.
const SalesBibleLifecycleModal: React.FC<{
  row: SalesBibleRow | null;
  onClose: () => void;
}> = ({ row, onClose }) => {
  if (!row) return null;
  return (
    <Modal isOpen onClose={onClose} isCentered size="lg" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {row.jobName}
          <Badge ml={3} colorScheme={STATE_COLOR[row.state]} variant="solid">{row.state}</Badge>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {row.verdict ? (
            <Text fontSize="sm" fontWeight="bold" color="orange.300" mb={4}>{row.verdict}</Text>
          ) : (
            <Text fontSize="sm" fontWeight="bold" color="green.300" mb={4}>
              Every rule is satisfied — this job is fully processed.
            </Text>
          )}
          {(row.lifecycle ?? []).map((st) => (
            <Flex
              key={st.label}
              align="flex-start"
              py={2}
              px={3}
              borderRadius="md"
              mb={1}
              bg={st.done ? 'rgba(72,187,120,0.08)' : 'rgba(229,62,62,0.08)'}
              cursor={st.href ? 'pointer' : 'default'}
              _hover={st.href ? { opacity: 0.8 } : undefined}
              // item 1458 (Chad: "all links from sales bible should open in a new tab")
              onClick={() => { if (st.href) window.open(st.href, '_blank', 'noopener'); }}
            >
              <Box
                as={st.done ? FiCheckCircle : FiXCircle}
                color={st.done ? 'green.400' : 'red.400'}
                mt="2px"
                mr={3}
                flexShrink={0}
              />
              <Box minW={0}>
                <Text fontSize="sm" fontWeight="semibold">
                  {st.label}
                  {st.href && <Box as={FiExternalLink} display="inline-block" ml={1.5} mb="-2px" opacity={0.6} />}
                </Text>
                {st.detail && <Text fontSize="xs" opacity={0.7}>{st.detail}</Text>}
              </Box>
            </Flex>
          ))}
          <Text fontSize="xs" opacity={0.6} mt={3}>
            {/* item 1258 (Chad) — payment no longer gates Completed */}
            Completed = $0 left to bill — every invoice generated and finalized (or the proposal
            manually marked Complete). Whether the money is in shows in the PAYMENT column;
            it never holds the job&apos;s status back. This report grades exactly those rules.
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SalesBibleLifecycleModal;
